// dateUtils.js
import moment from "moment";

export const formatDate = (date, format = "MMMM Do, YYYY") => {
  return moment(date).format(format);
};

export const formatTime = (time) => {
  if (!time) {
    return null;
  }
  const [hours, minutes, seconds] = time.split(":");

  // Create a Date object
  const date = new Date();
  date.setUTCHours(hours, minutes, seconds); // Set time in UTC

  // Convert to Kolkata (IST) timezone
  return date.toLocaleTimeString("en-IN", {
    timeZone: "Asia/Kolkata",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};

export const addPrefix = (value, label) => {
  if (label.includes("amount")) {
    return `₹${value}`;
  }
  if (label.includes("duration")) {
    return `${value} Days`;
  }
  return value;
};
